import { createAction, handleActions } from 'redux-actions';
import { produce } from 'immer';
import createRequestSaga, { createRequestActionTypes } from '../lib/createRequestSaga';
import * as csAPI from '../lib/api/cs';
import { takeLatest, put } from '@redux-saga/core/effects';
import { call } from 'redux-saga/effects';
import { race, delay } from 'redux-saga/effects';
import * as FileSaver from 'file-saver';
import { select } from 'redux-saga/effects';
import history from '../history';

const INITIALIZE_FORM = 'cs/INITIALIZE_FORM';
const INIT_USER = 'cs/INIT_USER';
const [LIST_DEVICES, LIST_DEVICES_SUCCESS, LIST_DEVICES_FAILURE] =
  createRequestActionTypes('cs/LIST_DEVICES');
const [LIST_DEVICES_EXCEL, LIST_DEVICES_EXCEL_SUCCESS, LIST_DEVICES_EXCEL_FAILURE] =
  createRequestActionTypes('cs/LIST_DEVICES_EXCEL');
const [
  GET_TOTAL_DEVICES_COUNT,
  GET_TOTAL_DEVICES_COUNT_SUCCESS,
  GET_TOTAL_DEVICES_COUNT_FAILURE,
] = createRequestActionTypes('cs/GET_TOTAL_DEVICES_COUNT');

const [
  ADD_PARTNER_FEATURES,
  ADD_PARTNER_FEATURES_SUCCESS,
  ADD_PARTNER_FEATURES_FAILURE,
] = createRequestActionTypes('cs/ADD_PARTNER_FEATURES');

const CLEAR_PARTNER_FEATURES_UPLOAD_RESULT = 'cs/CLEAR_PARTNER_FEATURES_UPLOAD_RESULT';

const [
  LIST_USER_REGISTRATIONS,
  LIST_USER_REGISTRATIONS_SUCCESS,
  LIST_USER_REGISTRATIONS_FAILURE,
] = createRequestActionTypes('cs/LIST_USER_REGISTRATIONS');
const [LIST_USERS, LIST_USERS_SUCCESS, LIST_USERS_FAILURE] =
  createRequestActionTypes('cs/LIST_USERS');
const [LIST_USERS_EXCEL, LIST_USERS_EXCEL_SUCCESS, LIST_USERS_EXCEL_FAILURE] =
  createRequestActionTypes('cs/LIST_USERS_EXCEL');
const [USER, USER_SUCCESS, USER_FAILURE] = createRequestActionTypes('cs/USER');
const [LIST_CASES, LIST_CASES_SUCCESS, LIST_CASES_FAILURE] =
  createRequestActionTypes('cs/LIST_CASES');
const INIT_GROUP = 'cs/INIT_GROUP';
const [GROUP, GROUP_SUCCESS, GROUP_FAILURE] = createRequestActionTypes('cs/GROUP');
const [LIST_CONNS, LIST_CONNS_SUCCESS, LIST_CONNS_FAILURE] =
  createRequestActionTypes('cs/LIST_CONNS');
const [STATS, STATS_SUCCESS, STATS_FAILURE] = createRequestActionTypes('cs/STATS');
const [LIST_TICKETS, LIST_TICKETS_SUCCESS, LIST_TICKETS_FAILURE] =
  createRequestActionTypes('cs/LIST_TICKETS');
const [LIST_LABS, LIST_LABS_SUCCESS, LIST_LABS_FAILURE] =
  createRequestActionTypes('cs/LIST_LABS');
const [REGISTER_LAB, REGISTER_LAB_SUCCESS, REGISTER_LAB_FAILURE] =
  createRequestActionTypes('cs/REGISTER_LAB');
const [EDIT_LAB, EDIT_LAB_SUCCESS, EDIT_LAB_FAILURE] =
  createRequestActionTypes('cs/EDIT_LAB');
const CHANGE_FIELD = 'cs/CHANGE_FIELD';
const [LIST_LAB, LIST_LAB_SUCCESS, LIST_LAB_FAILURE] =
  createRequestActionTypes('cs/LIST_LAB');

const LIST_PARTNER_FEATURES = 'cs/LIST_PARTNER_FEATURES';
const LIST_PARTNER_FEATURES_SUCCESS = 'cs/LIST_PARTNER_FEATURES_SUCCESS';
const LIST_PARTNER_FEATURES_FAILURE = 'cs/LIST_PARTNER_FEATURES_FAILURE';

const [LIST_LICENCE_KEYS, LIST_LICENCE_KEYS_SUCCESS, LIST_LICENCE_KEYS_FAILURE] =
  createRequestActionTypes('cs/LIST_LICENCE_KEYS');

const [
  UPDATE_PARTNER_FEATURE_OPTION,
  UPDATE_PARTNER_FEATURE_OPTION_SUCCESS,
  UPDATE_PARTNER_FEATURE_OPTION_FAILURE,
] = createRequestActionTypes('cs/UPDATE_PARTNER_FEATURE_OPTION');

const DOWNLOAD_PARTNER_FEATURES_EXCEL = 'cs/DOWNLOAD_PARTNER_FEATURES_EXCEL';

const [
  DELETE_PARTNER_FEATURES,
  DELETE_PARTNER_FEATURES_SUCCESS,
  DELETE_PARTNER_FEATURES_FAILURE,
] = createRequestActionTypes('cs/DELETE_PARTNER_FEATURES');

const [
  LIST_VERSION_CHECKS,
  LIST_VERSION_CHECKS_SUCCESS,
  LIST_VERSION_CHECKS_FAILURE,
] = createRequestActionTypes('cs/LIST_VERSION_CHECKS');
const [LIST_VERSION_CHECK_MODELS, LIST_VERSION_CHECK_MODELS_SUCCESS, LIST_VERSION_CHECK_MODELS_FAILURE] =
  createRequestActionTypes('cs/LIST_VERSION_CHECK_MODELS');
const [
  LIST_RELEASES,
  LIST_RELEASES_SUCCESS,
  LIST_RELEASES_FAILURE,
] = createRequestActionTypes('cs/LIST_RELEASES');

const SET_DEFAULT_VERSION = 'cs/SET_DEFAULT_VERSION';
const SET_DEFAULT_VERSION_SUCCESS = 'cs/SET_DEFAULT_VERSION_SUCCESS';
const SET_DEFAULT_VERSION_FAILURE = 'cs/SET_DEFAULT_VERSION_FAILURE';

const SET_DEVICE_TARGET_VERSIONS = 'cs/SET_DEVICE_TARGET_VERSIONS';
const SET_DEVICE_TARGET_VERSIONS_SUCCESS = 'cs/SET_DEVICE_TARGET_VERSIONS_SUCCESS';
const SET_DEVICE_TARGET_VERSIONS_FAILURE = 'cs/SET_DEVICE_TARGET_VERSIONS_FAILURE';

const [LIST_REGIONS, LIST_REGIONS_SUCCESS, LIST_REGIONS_FAILURE] =
  createRequestActionTypes('cs/LIST_REGIONS');

const [REGION_DEVICES, REGION_DEVICES_SUCCESS, REGION_DEVICES_FAILURE] =
  createRequestActionTypes('cs/REGION_DEVICES');

const [UPDATE_REGION_COUNTRIES, UPDATE_REGION_COUNTRIES_SUCCESS, UPDATE_REGION_COUNTRIES_FAILURE] =
  createRequestActionTypes('cs/UPDATE_REGION_COUNTRIES');

const [LIST_REGION_COUNTRIES, LIST_REGION_COUNTRIES_SUCCESS, LIST_REGION_COUNTRIES_FAILURE] =
  createRequestActionTypes('cs/LIST_REGION_COUNTRIES');

const [ADD_REGION_COUNTRY, ADD_REGION_COUNTRY_SUCCESS, ADD_REGION_COUNTRY_FAILURE] =
  createRequestActionTypes('cs/ADD_REGION_COUNTRY');

const [DELETE_REGION_COUNTRIES, DELETE_REGION_COUNTRIES_SUCCESS, DELETE_REGION_COUNTRIES_FAILURE] =
  createRequestActionTypes('cs/DELETE_REGION_COUNTRIES');

export const deletePartnerFeatures = createAction(
  DELETE_PARTNER_FEATURES,
  (udis) => udis,
);

export const initializeForm = createAction(INITIALIZE_FORM, (form) => form);
export const initUser = createAction(INIT_USER);
export const listDevicesExcel = createAction(LIST_DEVICES_EXCEL);
export const downloadPartnerFeaturesExcel = () => ({
  type: DOWNLOAD_PARTNER_FEATURES_EXCEL,
});
export const listDevices = createAction(
  LIST_DEVICES,
  ({ filters, page, registered }) => ({
    filters,
    page,
    registered,
  }),
);
export const listUserRegistrations = createAction(
  LIST_USER_REGISTRATIONS,
  ({ filters, page }) => ({
    filters,
    page,
  }),
);
export const listUsers = createAction(LIST_USERS, ({ filters, page }) => ({
  filters,
  page,
}));
export const listUsersExcel = createAction(LIST_USERS_EXCEL);
export const getTotalDevicesCount = createAction(GET_TOTAL_DEVICES_COUNT);
export const getUser = createAction(USER, (uid) => uid);
export const listCases = createAction(LIST_CASES, ({ filters, page }) => ({
  filters,
  page,
}));
export const initGroup = createAction(INIT_GROUP);
export const getGroup = createAction(GROUP, (gid) => gid);
export const listConns = createAction(LIST_CONNS, ({ filters, page }) => ({
  filters,
  page,
}));
export const getStats = createAction(STATS);
export const listTickets = createAction(LIST_TICKETS, ({ filters, page }) => ({
  filters,
  page,
}));
export const listLabs = createAction(LIST_LABS, ({ filters, page }) => ({
  filters,
  page,
}));
export const register_Lab = createAction(REGISTER_LAB, ({ formData }) => ({
  formData,
}));
export const edit_Lab = createAction(EDIT_LAB, ({ id, formData }) => ({
  id,
  formData,
}));
export const changeField = createAction(CHANGE_FIELD, ({ form, key, value }) => ({
  form,
  key,
  value,
}));
export const listLab = createAction(LIST_LAB, ({ id }) => ({
  id,
}));

export const listPartnerFeatures = createAction(
  LIST_PARTNER_FEATURES,
  ({ searchString } = {}) => ({ searchString }),
);

export const addPartnerFeatures = createAction(
  ADD_PARTNER_FEATURES,
  (formData) => formData,
);

export const clearPartnerFeaturesUploadResult = createAction(
  CLEAR_PARTNER_FEATURES_UPLOAD_RESULT,
);

export const listVersionChecks = createAction(LIST_VERSION_CHECKS, ({ filters, page, pageSize }) => ({
  filters,
  page,
  pageSize
}));

export const listVersionCheckModels = createAction(LIST_VERSION_CHECK_MODELS);

export const listReleases = createAction(LIST_RELEASES, ({ filters, page }) => ({
  filters,
  page,
}));
export const setDefaultVersionRelease = createAction(
  SET_DEFAULT_VERSION,
  ({ releaseId }) => ({ releaseId }),
);

export const setDeviceTargetVersions = createAction(
  SET_DEVICE_TARGET_VERSIONS,
  ({ devices }) => ({ devices }),
);

export const listRegions = createAction(LIST_REGIONS);

export const getRegionDevices = createAction(
  REGION_DEVICES,
  ({ region, search, page, pageSize }) => ({ region, search, page, pageSize })
);

export const updateRegionCountries = createAction(
  UPDATE_REGION_COUNTRIES,
  ({ regionId, countryCodes }) => ({ regionId, countryCodes })
);

export const listRegionCountries = createAction(
  LIST_REGION_COUNTRIES,
  ({ region, search, page, pageSize }) => ({ region, search, page, pageSize })
);

export const addRegionCountry = createAction(
  ADD_REGION_COUNTRY,
  ({ region, countryName }) => ({ region, countryName })
);

export const deleteRegionCountries = createAction(
  DELETE_REGION_COUNTRIES,
  ({ ids }) => ({ ids })
);

function* getTotalDevicesCountSaga() {
  try {
    const response = yield csAPI.listDevices({ filters: {}, page: 1 });
    const count = response.data && response.data.page ? response.data.page.count : 0;
    yield put({
      type: GET_TOTAL_DEVICES_COUNT_SUCCESS,
      payload: count,
    });
  } catch (e) {
    yield put({ type: GET_TOTAL_DEVICES_COUNT_FAILURE, payload: e });
  }
}

function* listPartnerFeaturesSaga(action) {
  try {
    const searchString = action.payload?.searchString || '';
    const response = yield call(csAPI.listPartnerFeatures, { searchString });
    yield put({ type: LIST_PARTNER_FEATURES_SUCCESS, payload: response.data });
  } catch (e) {
    yield put({ type: LIST_PARTNER_FEATURES_FAILURE, payload: e });
  }
}

export const updatePartnerFeatureOption = createAction(
  UPDATE_PARTNER_FEATURE_OPTION,
  ({ id, option }) => ({ id, option }),
);

function* updatePartnerFeatureOptionSaga(action) {
  const { id, option } = action.payload;
  const { resolve, reject } = action.meta || {};
  const API_TIMEOUT = 15000;

  try {
    const { response, timeout } = yield race({
      response: call(csAPI.updatePartnerFeatureOption, { id, option }),
      timeout: delay(API_TIMEOUT),
    });

    if (timeout) {
      const timeoutError = new Error(`API call timed out for feature ID ${id}`);
      yield put({
        type: 'cs/UPDATE_PARTNER_FEATURE_OPTION_FAILURE',
        payload: timeoutError,
        error: true,
      });
      if (reject) reject(timeoutError);
    } else {
      yield put({
        type: 'cs/UPDATE_PARTNER_FEATURE_OPTION_SUCCESS',
        payload: { id, option },
      });
      if (resolve) resolve();
    }
  } catch (e) {
    yield put({
      type: 'cs/UPDATE_PARTNER_FEATURE_OPTION_FAILURE',
      payload: e,
      error: true,
    });
    if (reject) reject(e);
  }
}

function* downloadPartnerFeaturesExcelSaga() {
  try {
    const partnerFeatures = yield select((state) => state.cs.partnerFeatures) || [];
    const xlsx = yield call(() => import('xlsx'));
    const ws = xlsx.utils.aoa_to_sheet([
      ['UDI', 'Option'],
      ...partnerFeatures.map((feature) => [feature.udi, feature.option ? 'Yes' : 'No']),
    ]);
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = xlsx.write(wb, { bookType: 'xlsx', type: 'array' });
    const fileData = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    FileSaver.saveAs(fileData, 'PartnerFeatures.xlsx');
  } catch (e) {
    console.error(e);
  }
}

function* addPartnerFeaturesSaga(action) {
  try {
    const response = yield call(csAPI.addPartnerFeatures, action.payload);
    yield put({ type: ADD_PARTNER_FEATURES_SUCCESS, payload: response.data });
    yield put(listPartnerFeatures());
  } catch (e) {
    yield put({ type: ADD_PARTNER_FEATURES_FAILURE, payload: e, error: true });
  }
}

function* deletePartnerFeaturesSaga(action) {
  try {
    yield call(csAPI.deletePartnerFeatures, action.payload);
    yield put({ type: DELETE_PARTNER_FEATURES_SUCCESS });
    yield put(listPartnerFeatures());
  } catch (e) {
    yield put({ type: DELETE_PARTNER_FEATURES_FAILURE, payload: e });
  }
}

export const listLicenceKeys = createAction(
  LIST_LICENCE_KEYS,
  ({ filters = {}, page = 1 } = {}) => ({ filters, page }),
);

const listLicenceKeysSata = createRequestSaga(LIST_LICENCE_KEYS, csAPI.listLicenceKeys);

const listDevicesExcelSaga = createRequestSaga(
  LIST_DEVICES_EXCEL,
  csAPI.listDevicesExcel,
);
const listDevicesSaga = createRequestSaga(LIST_DEVICES, csAPI.listDevices);
const listUserRegistrationsSaga = createRequestSaga(
  LIST_USER_REGISTRATIONS,
  csAPI.listUserRegistrations,
);
const listUsersSaga = createRequestSaga(LIST_USERS, csAPI.listUsers);
const listUsersExcelSaga = createRequestSaga(LIST_USERS_EXCEL, csAPI.listUsersExcel);
const userSaga = createRequestSaga(USER, csAPI.getUser);
const listCasesSaga = createRequestSaga(LIST_CASES, csAPI.listCases);
const groupSaga = createRequestSaga(GROUP, csAPI.getGroup);
const listConnsSaga = createRequestSaga(LIST_CONNS, csAPI.listConns);
const statsSaga = createRequestSaga(STATS, csAPI.getStats);
const listTicketsSaga = createRequestSaga(LIST_TICKETS, csAPI.listTickets);
const listLabsSaga = createRequestSaga(LIST_LABS, csAPI.listLabs);
const registerLabSaga = createRequestSaga(REGISTER_LAB, csAPI.labRegister);
const editLabSaga = createRequestSaga(EDIT_LAB, csAPI.editLab);
const listLabSaga = createRequestSaga(LIST_LAB, csAPI.listLab);
const listVersionChecksSaga = createRequestSaga(LIST_VERSION_CHECKS, csAPI.listVersionChecks);
const listVersionCheckModelsSaga = createRequestSaga(LIST_VERSION_CHECK_MODELS, csAPI.listVersionCheckModels);
const listReleasesSaga = createRequestSaga(LIST_RELEASES, csAPI.listReleases);
const setDeviceTargetVersionsSaga = createRequestSaga(
  SET_DEVICE_TARGET_VERSIONS,
  csAPI.setDeviceTargetVersions,
);
const setDefaultVersionReleaseSaga = createRequestSaga(
  SET_DEFAULT_VERSION,
  csAPI.setDefaultVersionRelease,
);
const listRegionsSaga = createRequestSaga(LIST_REGIONS, csAPI.listRegions);
const regionDevicesSaga = createRequestSaga(REGION_DEVICES, csAPI.getRegionDevices);
const updateRegionCountriesSaga = createRequestSaga(UPDATE_REGION_COUNTRIES, csAPI.updateRegionCountries);
const listRegionCountriesSaga = createRequestSaga(LIST_REGION_COUNTRIES, csAPI.getRegionCountries);
const addRegionCountrySaga = createRequestSaga(ADD_REGION_COUNTRY, csAPI.addRegionCountry);
const deleteRegionCountriesSaga = createRequestSaga(DELETE_REGION_COUNTRIES, csAPI.deleteRegionCountries);

function* registerLabSuccessSaga({ payload }) {
  yield call([history, history.push], '/adm/labs');
  yield put(initializeForm('lab'));
}

export function* csSaga() {
  yield takeLatest(LIST_DEVICES_EXCEL, listDevicesExcelSaga);
  yield takeLatest(LIST_DEVICES, listDevicesSaga);
  yield takeLatest(LIST_USER_REGISTRATIONS, listUserRegistrationsSaga);
  yield takeLatest(LIST_USERS, listUsersSaga);
  yield takeLatest(LIST_USERS_EXCEL, listUsersExcelSaga);
  yield takeLatest(GET_TOTAL_DEVICES_COUNT, getTotalDevicesCountSaga);
  yield takeLatest(USER, userSaga);
  yield takeLatest(LIST_CASES, listCasesSaga);
  yield takeLatest(GROUP, groupSaga);
  yield takeLatest(LIST_CONNS, listConnsSaga);
  yield takeLatest(STATS, statsSaga);
  yield takeLatest(LIST_TICKETS, listTicketsSaga);
  yield takeLatest(LIST_LABS, listLabsSaga);
  yield takeLatest(REGISTER_LAB, registerLabSaga);
  yield takeLatest(REGISTER_LAB_SUCCESS, registerLabSuccessSaga);
  yield takeLatest(EDIT_LAB, editLabSaga);
  yield takeLatest(EDIT_LAB_SUCCESS, registerLabSuccessSaga);
  yield takeLatest(LIST_LAB, listLabSaga);
  yield takeLatest(LIST_PARTNER_FEATURES, listPartnerFeaturesSaga);
  yield takeLatest(UPDATE_PARTNER_FEATURE_OPTION, updatePartnerFeatureOptionSaga);
  yield takeLatest(DOWNLOAD_PARTNER_FEATURES_EXCEL, downloadPartnerFeaturesExcelSaga);
  yield takeLatest(ADD_PARTNER_FEATURES, addPartnerFeaturesSaga);
  yield takeLatest(DELETE_PARTNER_FEATURES, deletePartnerFeaturesSaga);
  yield takeLatest(LIST_LICENCE_KEYS, listLicenceKeysSata);
  yield takeLatest(LIST_VERSION_CHECKS, listVersionChecksSaga);
  yield takeLatest(LIST_VERSION_CHECK_MODELS, listVersionCheckModelsSaga);
  yield takeLatest(LIST_RELEASES, listReleasesSaga);
  yield takeLatest(SET_DEFAULT_VERSION, setDefaultVersionReleaseSaga);
  yield takeLatest(SET_DEVICE_TARGET_VERSIONS, setDeviceTargetVersionsSaga);
  yield takeLatest(LIST_REGIONS, listRegionsSaga);
  yield takeLatest(REGION_DEVICES, regionDevicesSaga);
  yield takeLatest(UPDATE_REGION_COUNTRIES, updateRegionCountriesSaga);
  yield takeLatest(LIST_REGION_COUNTRIES, listRegionCountriesSaga);
  yield takeLatest(ADD_REGION_COUNTRY, addRegionCountrySaga);
  yield takeLatest(DELETE_REGION_COUNTRIES, deleteRegionCountriesSaga);
}

const initialState = {
  // page: null,
  devices: null,
  // deviceModels: null,
  user_regs: null,
  users: null,
  user: null,
  cases: null,
  group: null,
  conns: null,
  stats: null,
  tickets: null,
  labs: null,
  lab: {
    name: '',
    email: '', //(hcd lab account)
    company_name: '',
    company_address: '',
    contact_name: '',
    contact_email: '',
    contact_phone: '',
    lab_logo: '',
    country: '',
    is_active: true,
  },
  error: null,
  users_excel: null,
  devices_excel: null,
  totalDevicesCount: null,
  partnerFeatures: [],
  partnerFeaturesSearchString: '',
  partnerFeaturesUploadResult: null,
  partnerFeaturesUploadError: null,
  loadingAddPartnerFeatures: false,
  licenceKeys: null,
  versionChecks: null,
  versionChecksError: null,
  versionCheckModels: [],
  versionCheckModelsError: null,
  versionReleases: null,
  versionReleasesError: null,
  setTargetVersionsResult: null,
  setTargetVersionsError: null,
  releases: null,
  releasesError: null,
  setDefaultVersionResult: null,
  setDefaultVersionError: null,
  regions: null,
  regionsError: null,
  regionDevices: null,
  regionDevicesError: null,
  regionCountries: null,
  regionCountriesError: null,
};

const cs = handleActions(
  {
    [CHANGE_FIELD]: (state, { payload: { form, key, value } }) =>
      produce(state, (draft) => {
        draft[form][key] = value;
      }),
    [INITIALIZE_FORM]: (state, { payload: form }) => ({
      ...state,
      [form]: initialState[form],
      auth: null,
      authError: null,
    }),
    [INIT_USER]: (state) => ({
      ...state,
      user: null,
    }),
    [LIST_DEVICES_EXCEL_SUCCESS]: (state, { payload: devices_excel }) => ({
      ...state,
      devices_excel,
      error: null,
    }),
    [LIST_DEVICES_EXCEL_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [LIST_DEVICES_SUCCESS]: (state, { payload: devices }) => ({
      ...state,
      // devices: devices.devices,
      // page: devices.page,
      // deviceModels: devices.deviceModels,
      devices,
      error: null,
    }),
    [LIST_DEVICES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [GET_TOTAL_DEVICES_COUNT_SUCCESS]: (state, { payload }) => ({
      ...state,
      totalDevicesCount: payload,
    }),
    [LIST_USER_REGISTRATIONS_SUCCESS]: (state, { payload: user_regs }) => ({
      ...state,
      user_regs,
      error: null,
    }),
    [LIST_USER_REGISTRATIONS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [LIST_USERS_SUCCESS]: (state, { payload: users }) => ({
      ...state,
      // users: users.users,
      // page: users.page,
      users,
      error: null,
    }),
    [LIST_USERS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [LIST_USERS_EXCEL_SUCCESS]: (state, { payload: users_excel }) => ({
      ...state,
      users_excel: users_excel.users_excel,
      error: null,
    }),
    [LIST_USERS_EXCEL_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [USER_SUCCESS]: (state, { payload: user }) => ({
      ...state,
      user,
      error: null,
    }),
    [USER_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [LIST_CASES_SUCCESS]: (state, { payload: cases }) => ({
      ...state,
      // cases: cases.cases,
      // page: cases.page,
      cases,
      error: null,
    }),
    [LIST_CASES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [INIT_GROUP]: (state) => ({
      ...state,
      group: null,
    }),
    [GROUP_SUCCESS]: (state, { payload: group }) => ({
      ...state,
      group,
      error: null,
    }),
    [GROUP_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [LIST_CONNS_SUCCESS]: (state, { payload: conns }) => ({
      ...state,
      // conns: conns.conns,
      // page: conns.page,
      conns,
      error: null,
    }),
    [LIST_CONNS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [STATS_SUCCESS]: (state, { payload: stats }) => ({
      ...state,
      stats,
      error: null,
    }),
    [STATS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [LIST_TICKETS_SUCCESS]: (state, { payload: tickets }) => ({
      ...state,
      // tickets: tickets.tickets,
      // page: tickets.page,
      tickets,
      error: null,
    }),
    [LIST_TICKETS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [LIST_LABS_SUCCESS]: (state, { payload: labs }) => ({
      ...state,
      labs,
      error: null,
    }),
    [LIST_LABS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [REGISTER_LAB_SUCCESS]: (state, { payload: lab }) => ({
      ...state,
      error: null,
    }),
    [REGISTER_LAB_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [EDIT_LAB_SUCCESS]: (state, { payload: lab }) => ({
      ...state,
      error: null,
    }),
    [EDIT_LAB_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [LIST_LAB_SUCCESS]: (state, { payload: lab }) => ({
      ...state,
      lab,
      error: null,
    }),
    [LIST_LAB_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [LIST_PARTNER_FEATURES]: (state, action) => ({
      ...state,
      partnerFeaturesSearchString: action.payload?.searchString || '',
    }),
    [LIST_PARTNER_FEATURES_SUCCESS]: (state, { payload }) => ({
      ...state,
      partnerFeatures: payload,
    }),
    [LIST_PARTNER_FEATURES_FAILURE]: (state, { payload }) => ({
      ...state,
      error: payload,
    }),
    [UPDATE_PARTNER_FEATURE_OPTION_SUCCESS]: (state, { payload }) => ({
      ...state,
      partnerFeatures: state.partnerFeatures.map((feature) =>
        feature.id === payload.id ? { ...feature, option: payload.option } : feature,
      ),
    }),
    [ADD_PARTNER_FEATURES]: (state) => ({
      ...state,
      loadingAddPartnerFeatures: true,
      partnerFeaturesUploadResult: null,
      partnerFeaturesUploadError: null,
    }),
    [ADD_PARTNER_FEATURES_SUCCESS]: (state, { payload }) => ({
      ...state,
      loadingAddPartnerFeatures: false,
      partnerFeaturesUploadResult: payload,
      partnerFeaturesUploadError: null,
    }),
    [ADD_PARTNER_FEATURES_FAILURE]: (state, { payload }) => ({
      ...state,
      loadingAddPartnerFeatures: false,
      partnerFeaturesUploadResult: null,
      partnerFeaturesUploadError: payload,
    }),
    [CLEAR_PARTNER_FEATURES_UPLOAD_RESULT]: (state) => ({
      ...state,
      partnerFeaturesUploadResult: null,
      partnerFeaturesUploadError: null,
      loadingAddPartnerFeatures: false,
    }),
    [LIST_LICENCE_KEYS_SUCCESS]: (state, { payload: licenceKeys }) => ({
      ...state,
      licenceKeys,
      error: null,
    }),
    [LIST_LICENCE_KEYS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [LIST_VERSION_CHECKS_SUCCESS]: (state, { payload }) => ({
      ...state,
      versionChecks: payload,
      versionChecksError: null,
    }),
    [LIST_VERSION_CHECKS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      versionChecks: null,
      versionChecksError: error,
    }),
    [LIST_VERSION_CHECK_MODELS_SUCCESS]: (state, { payload }) => ({
      ...state,
      versionCheckModels: payload,
      versionCheckModelsError: null,
    }),
    [LIST_VERSION_CHECK_MODELS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      versionCheckModels: [],
      versionCheckModelsError: error,
    }),
    [LIST_RELEASES_SUCCESS]: (state, { payload }) => ({
      ...state,
      versionReleases: payload,
      versionReleasesError: null,
    }),
    [LIST_RELEASES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      versionReleases: null,
      versionReleasesError: error,
    }),
    [SET_DEFAULT_VERSION_SUCCESS]: (state, { payload }) => ({
      ...state,
      setDefaultVersionResult: payload,
      setDefaultVersionError: null,
    }),
    [SET_DEFAULT_VERSION_FAILURE]: (state, { payload: error }) => ({
      ...state,
      setDefaultVersionError: error,
    }),
    [LIST_REGIONS_SUCCESS]: (state, { payload }) => ({
      ...state,
      regions: payload,
      regionsError: null,
    }),
    [LIST_REGIONS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      regionsError: error,
    }),
    [REGION_DEVICES_SUCCESS]: (state, { payload }) => ({
      ...state,
      regionDevices: payload,
      regionDevicesError: null,
    }),
    [REGION_DEVICES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      regionDevicesError: error,
    }),
    [LIST_REGION_COUNTRIES_SUCCESS]: (state, { payload }) => ({
      ...state,
      regionCountries: payload,
      regionCountriesError: null,
    }),
    [LIST_REGION_COUNTRIES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      regionCountriesError: error,
    }),
    [ADD_REGION_COUNTRY_SUCCESS]: (state) => ({
      ...state,
      regionCountriesError: null,
    }),
    [ADD_REGION_COUNTRY_FAILURE]: (state, { payload: error }) => ({
      ...state,
      regionCountriesError: error,
    }),
    [DELETE_REGION_COUNTRIES_SUCCESS]: (state) => ({
      ...state,
      regionCountriesError: null,
    }),
    [DELETE_REGION_COUNTRIES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      regionCountriesError: error,
    }),
  },
  initialState,
);

export default cs;
